import { render, staticRenderFns } from "./balanceWithTable.vue?vue&type=template&id=1e87bc50&"
import script from "./balanceWithTable.vue?vue&type=script&lang=js&"
export * from "./balanceWithTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports